module.exports = __webpack_public_path__ + "img/zz.eadd5d45.png";